import React from "react";

type Props = {
  fill?: string;
};
export const HomeIcon: React.FC<Props> = ({ fill = "#828282" }) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5698 15.8328V8.50352C17.5698 7.66736 17.1521 6.88653 16.4566 6.42271L10.9943 2.78001C10.4345 2.40666 9.70516 2.40666 9.14532 2.78001L3.68307 6.42271C2.98758 6.88653 2.56982 7.66736 2.56982 8.50352V15.8328C2.56982 16.7536 3.31602 17.5 4.23649 17.5H7.15316C7.61339 17.5 7.98649 17.1268 7.98649 16.6664V14.5824C7.98649 13.6616 8.73268 12.9152 9.65316 12.9152H10.4865C11.407 12.9152 12.1532 13.6616 12.1532 14.5824V16.6664C12.1532 17.1268 12.5263 17.5 12.9865 17.5H15.9032C16.8236 17.5 17.5698 16.7536 17.5698 15.8328Z"
      stroke={fill}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
